import { useState } from 'react';
import { Button } from '@accure/ui';
import { useBoolean } from 'usehooks-ts';

import { CreateRoleDialog } from '../components/create-role-dialog';
import { RolesTable } from '../components/roles-table';
import { type Role } from '../entities/role';

import { DeleteRoleConfirmationDialog } from './delete-role-confirmation-dialog';
import { EditRoleDialog } from './edit-role-dialog';

export function RolesManagement() {
  const createRoleDialog = useBoolean(false);
  const [editRoleDialog, setEditRoleDialog] = useState<Role | undefined>(
    undefined,
  );
  const [deleteRoleDialog, setDeleteRoleDialog] = useState<Role | undefined>(
    undefined,
  );

  return (
    <>
      <div className="space-y-4">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="space-y-2">
            <h2 className="text-xl font-semibold tracking-tight sm:text-2xl">
              Roles
            </h2>
            <p className="text-sm text-muted-foreground sm:text-base">
              Define permissions and access levels for your users
            </p>
          </div>
          <Button
            size="sm"
            className="w-full bg-primary-500 px-4 text-white transition-colors hover:bg-primary-400 sm:w-auto"
            onClick={createRoleDialog.setTrue}
          >
            Create Role
          </Button>
        </div>

        <div className="rounded-md border">
          <div className="relative w-full">
            <RolesTable
              onEditRole={(role) => setEditRoleDialog(role)}
              onDeleteRole={(role) => setDeleteRoleDialog(role)}
            />
          </div>
        </div>
      </div>

      <CreateRoleDialog
        open={createRoleDialog.value}
        onClose={createRoleDialog.setFalse}
      />

      <EditRoleDialog
        role={editRoleDialog}
        onClose={() => setEditRoleDialog(undefined)}
      />

      <DeleteRoleConfirmationDialog
        role={deleteRoleDialog}
        onClose={() => setDeleteRoleDialog(undefined)}
      />
    </>
  );
}
